module.exports = __webpack_public_path__ + "img/hzhs7.1c701498.jpg";